/*
 * Jamones Leandro · precios ya con el descuento de un código
 *
 * Qué hace
 *  - Si el visitante llega con un código guardado (cookie "discount_code", la que crea Shopify al entrar por un
 *    enlace /discount/CÓDIGO) y ese código está en la tabla de snippets/jl-codigos.liquid, enseña en toda la web el
 *    precio original tachado, el precio con el descuento y la línea «Con tu código X · precio final al pagar».
 *  - Añade un enlace «¿Tienes un código de descuento?» (barra superior y ficha de producto) para escribir un código
 *    sin haber entrado por enlace.
 *
 * Qué NO hace: no llama al carrito (/cart/*) al cargar ni al pintar precios, no toca la cookie salvo cuando la persona
 * aplica o quita un código a mano, y no cambia el descuento real (lo calcula Shopify al pagar). Todo el cálculo es en
 * el navegador. La única llamada al carrito es /cart/update.js con {discount: ''}, solo cuando la persona pulsa
 * «Quitar» o «Aplicar» (para que el código anterior no se quede en el carrito).
 * La tabla de códigos se amplía en snippets/jl-codigos.liquid (no hay que tocar este fichero).
 */
(function () {
  'use strict';
  if (window.JLDescuento) return;

  var tablaEl = document.getElementById('jl-codigos');
  if (!tablaEl) return;
  var datos;
  try { datos = JSON.parse(tablaEl.textContent); } catch (e) { return; }
  datos.codigos = datos.codigos || [];
  datos.colecciones = datos.colecciones || {};
  datos.etiquetas = datos.etiquetas || {};
  datos.ids = datos.ids || {};

  var SEL_PRECIOS = '.price-list, .product-sticky-form__price';
  // Zonas donde este script nunca toca nada: recorridos de Navidad del jamón (.jr) y de la cesta (.ces), la reserva
  // (.rv, .rc), las líneas del carrito y del cajón del carrito (ya vienen calculadas por Shopify) y el propio recuadro.
  var EXCLUIDOS = '[data-jl-sin-descuento], .jr, .ces, .rv, .rc, line-item, .line-item, .jl-cod-pop';
  var RE_IMPORTE = /(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})/;

  var activo = null; // entrada de la tabla que se está aplicando ahora mismo
  var sets = {};     // handle -> true, por colección o etiqueta (se construye al usarlos)
  var contador = 0;

  /* ---------- Utilidades ---------- */
  function ahora() { return Date.now(); }

  function leerCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).trim(); } catch (e) { return m[1].trim(); }
  }

  function buscarCodigo(nombre) {
    var n = String(nombre || '').trim().toUpperCase();
    if (!n) return null;
    for (var i = 0; i < datos.codigos.length; i++) {
      if (String(datos.codigos[i].codigo).toUpperCase() === n) return datos.codigos[i];
    }
    return null;
  }

  function vigente(c) {
    var t = ahora();
    var d = c.desde ? Date.parse(c.desde) : NaN;
    var h = c.hasta ? Date.parse(c.hasta) : NaN;
    if (!isNaN(d) && t < d) return false;
    if (!isNaN(h) && t > h) return false;
    return true;
  }

  function conjunto(tipo, nombre) {
    var clave = tipo + ':' + nombre;
    if (!sets[clave]) {
      var lista = (datos[tipo] && datos[tipo][nombre]) || [];
      var s = {};
      for (var i = 0; i < lista.length; i++) s[lista[i]] = true;
      sets[clave] = s;
    }
    return sets[clave];
  }

  function elegible(c, handle) {
    if (!handle) return false;
    var ex = c.excluirEtiquetas || [];
    for (var i = 0; i < ex.length; i++) {
      if (conjunto('etiquetas', ex[i])[handle]) return false;
    }
    var cols = c.colecciones || [];
    if (!cols.length) return true; // sin colecciones = todos los productos
    for (var j = 0; j < cols.length; j++) {
      if (conjunto('colecciones', cols[j])[handle]) return true;
    }
    return false;
  }

  // Redondeo a céntimos como Shopify: precio × (1 − %) con redondeo normal.
  function conDescuento(centimos, pct) {
    return Math.round(centimos * (100 - pct) / 100 + 1e-9);
  }

  // Formato es-ES de la tienda: 1.234,50
  function formatear(centimos) {
    var e = Math.floor(centimos / 100);
    var d = centimos % 100;
    return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (d < 10 ? '0' : '') + d;
  }

  function aCentimos(txt) {
    var m = RE_IMPORTE.exec(txt);
    if (!m) return null;
    return parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10);
  }

  function pct(c) {
    var n = Number(c.pct);
    return n > 0 && n < 100 ? n : 0;
  }

  /* ---------- Qué producto es cada precio ---------- */
  function handleDeHref(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function handleDePagina() {
    return handleDeHref(location.pathname);
  }

  function handleDe(el) {
    var x = el.closest('[data-jl-producto]');
    if (x) return x.getAttribute('data-jl-producto');

    var item = el.closest('product-item, .product-item, .product-item-meta');
    if (item) {
      var a = item.querySelector('a[href*="/products/"]');
      if (a) return handleDeHref(a.getAttribute('href'));
    }

    var pm = el.closest('product-meta');
    if (pm) {
      var idm = /(\d+)$/.exec(pm.getAttribute('form-id') || '');
      if (idm && datos.ids[idm[1]]) return datos.ids[idm[1]];
      if (handleDePagina()) return handleDePagina();
    }
    if (el.closest('.product-sticky-form') && handleDePagina()) return handleDePagina();

    // Subir por el DOM hasta un contenedor que enlace a un único producto.
    var n = el.parentElement;
    while (n && n !== document.body) {
      var enlaces = n.querySelectorAll('a[href*="/products/"]');
      if (enlaces.length) {
        var vistos = {}, cuantos = 0, uno = '';
        for (var i = 0; i < enlaces.length; i++) {
          var h = handleDeHref(enlaces[i].getAttribute('href'));
          if (h && !vistos[h]) { vistos[h] = true; cuantos++; uno = h; }
        }
        if (cuantos === 1) return uno;
        if (cuantos > 1) break;
      }
      n = n.parentElement;
    }
    return handleDePagina();
  }

  /* ---------- Pintar precios ---------- */
  function nodoImporte(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (RE_IMPORTE.test(n.nodeValue)) return n;
    }
    return null;
  }

  function crearOriginal(texto, grande) {
    var o = document.createElement('span');
    o.className = 'price price--compare jl-precio-orig' + (grande ? ' price--large' : '');
    var oculto = document.createElement('span');
    oculto.className = 'visually-hidden';
    oculto.textContent = 'Precio sin código ';
    o.appendChild(oculto);
    o.appendChild(document.createTextNode(texto));
    return o;
  }

  function crearAviso() {
    var p = document.createElement('span');
    p.className = 'jl-aviso-codigo';
    p.textContent = 'Con tu código ' + String(activo.codigo).toUpperCase() + ' · precio final al pagar';
    return p;
  }

  function primerPrecio(lista) {
    var hijos = lista.children;
    for (var i = 0; i < hijos.length; i++) {
      var h = hijos[i];
      if (!h.classList.contains('price')) continue;
      if (h.classList.contains('price--compare') || h.classList.contains('jl-precio-orig')) continue;
      if (h.querySelector('.unit-price-measurement')) continue;
      return h;
    }
    return null;
  }

  // Cambia el importe dentro de "el" y devuelve el texto original (con su moneda) o null si no hay importe.
  function sustituirImporte(el) {
    var nodo = nodoImporte(el);
    if (!nodo) return null;
    var cents = aCentimos(nodo.nodeValue);
    if (cents === null) return null;
    var nuevo = conDescuento(cents, pct(activo));
    var original = nodo.nodeValue.trim();
    nodo.nodeValue = nodo.nodeValue.replace(RE_IMPORTE, formatear(nuevo));
    return original;
  }

  function procesarLista(lista) {
    var P = primerPrecio(lista);
    if (!P || P.hasAttribute('data-jl-hecho')) return;
    if (!elegible(activo, handleDe(lista))) return;
    var html = P.innerHTML;
    var original = sustituirImporte(P);
    if (original === null) return;
    P.__jlHtml = html;
    P.setAttribute('data-jl-hecho', '1');
    P.parentNode.insertBefore(crearOriginal(original, P.classList.contains('price--large')), P.nextSibling);

    var ancla = lista.closest('.product-meta__price-list-container, .product-item-meta__price-list-container') || lista;
    var sig = ancla.nextElementSibling;
    if (!sig || !sig.classList.contains('jl-aviso-codigo')) {
      ancla.parentNode.insertBefore(crearAviso(), ancla.nextSibling);
    }
  }

  function procesarSticky(el) {
    if (el.querySelector('.jl-precio-orig')) return;
    if (!elegible(activo, handleDe(el))) return;
    var html = el.innerHTML;
    var original = sustituirImporte(el);
    if (original === null) return;
    el.__jlHtml = html;
    el.setAttribute('data-jl-hecho', '1');
    var o = document.createElement('span');
    o.className = 'jl-precio-orig';
    o.textContent = original;
    el.appendChild(o);
  }

  function escanear() {
    if (!activo) return;
    var els = document.querySelectorAll(SEL_PRECIOS);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest(EXCLUIDOS)) continue;
      try {
        if (el.classList.contains('product-sticky-form__price')) procesarSticky(el);
        else procesarLista(el);
      } catch (e) { /* un precio raro no debe romper la página */ }
    }
  }

  function restaurar() {
    var hechos = document.querySelectorAll('[data-jl-hecho]');
    for (var i = 0; i < hechos.length; i++) {
      var h = hechos[i];
      if (typeof h.__jlHtml === 'string') h.innerHTML = h.__jlHtml;
      h.removeAttribute('data-jl-hecho');
      h.__jlHtml = undefined;
    }
    var extra = document.querySelectorAll('.jl-precio-orig, .jl-aviso-codigo');
    for (var j = 0; j < extra.length; j++) extra[j].parentNode.removeChild(extra[j]);
  }

  /* ---------- Aviso superior (barra granate) ---------- */
  function barraAviso() { return document.querySelector('[data-jl-aviso-codigo]'); }

  function pintarBarra() {
    var bar = barraAviso();
    if (activo) {
      if (!bar) {
        bar = document.createElement('div');
        bar.style.cssText = 'background:#63111e;color:#f5ede0;text-align:center;padding:12px 16px;font-size:14px;line-height:1.4;';
        bar.setAttribute('data-jl-aviso-codigo', '');
        bar.setAttribute('data-jl-creada', '1');
        document.body.insertBefore(bar, document.body.firstChild);
      } else if (bar.__jlOriginal === undefined) {
        bar.__jlOriginal = bar.innerHTML;
      }
      bar.innerHTML = '';
      bar.appendChild(document.createTextNode('Código '));
      var s = document.createElement('strong');
      s.textContent = String(activo.codigo).toUpperCase();
      bar.appendChild(s);
      bar.appendChild(document.createTextNode(' aplicado · precios ya con descuento · '));
      var q = document.createElement('button');
      q.type = 'button';
      q.className = 'jl-quitar';
      q.textContent = 'Quitar';
      bar.appendChild(q);
    } else if (bar) {
      if (bar.hasAttribute('data-jl-creada')) bar.parentNode.removeChild(bar);
      else if (bar.__jlOriginal !== undefined) { bar.innerHTML = bar.__jlOriginal; bar.__jlOriginal = undefined; }
    }
  }

  /* ---------- Botón «¿Tienes un código?» ---------- */
  var panelBarra = null;
  var abierto = null; // { panel, boton }

  function etiquetaBoton() {
    return activo ? 'Cambiar código' : '¿Tienes un código de descuento?';
  }

  function crearPanel() {
    contador++;
    var id = 'jl-cod-input-' + contador;
    var panel = document.createElement('div');
    panel.className = 'jl-cod-pop';
    panel.id = 'jl-cod-pop-' + contador;
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Código de descuento');
    panel.hidden = true;

    var form = document.createElement('form');
    form.className = 'jl-cod-form';
    form.setAttribute('novalidate', '');

    var label = document.createElement('label');
    label.className = 'jl-cod-label';
    label.setAttribute('for', id);
    label.textContent = 'Escribe tu código';

    var fila = document.createElement('div');
    fila.className = 'jl-cod-fila';

    var input = document.createElement('input');
    input.type = 'text';
    input.id = id;
    input.className = 'jl-cod-input';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'characters');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('maxlength', '40');

    var boton = document.createElement('button');
    boton.type = 'submit';
    boton.className = 'jl-cod-aplicar';
    boton.textContent = 'Aplicar';

    var estado = document.createElement('p');
    estado.className = 'jl-cod-estado';
    estado.setAttribute('role', 'status');
    estado.setAttribute('aria-live', 'polite');

    fila.appendChild(input);
    fila.appendChild(boton);
    form.appendChild(label);
    form.appendChild(fila);
    form.appendChild(estado);
    panel.appendChild(form);
    return panel;
  }

  function crearBoton(controla) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'jl-cod-trigger';
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-controls', controla);
    b.textContent = etiquetaBoton();
    return b;
  }

  function montarBotones() {
    // 1. Barra de anuncios superior
    var msg = document.querySelector('#shopify-section-announcement-bar .announcement-bar__message p');
    if (msg && !msg.querySelector('.jl-cod-trigger')) {
      if (!panelBarra) {
        panelBarra = crearPanel();
        panelBarra.classList.add('jl-cod-pop--flotante');
        document.body.appendChild(panelBarra);
      }
      var sep = document.createElement('span');
      sep.className = 'jl-cod-sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = ' · ';
      msg.appendChild(sep);
      msg.appendChild(crearBoton(panelBarra.id));
      recalcularAlturaBarra();
    }

    // 2. Ficha de producto, bajo el precio
    var cont = document.querySelector('.product__info product-meta .product-meta__price-list-container');
    if (cont && !cont.parentNode.querySelector('.jl-cod-envoltorio')) {
      var env = document.createElement('div');
      env.className = 'jl-cod-envoltorio';
      var panel = crearPanel();
      panel.classList.add('jl-cod-pop--en-linea');
      env.appendChild(crearBoton(panel.id));
      env.appendChild(panel);
      var sig = cont.nextElementSibling;
      if (sig && sig.classList.contains('jl-aviso-codigo')) cont = sig;
      cont.parentNode.insertBefore(env, cont.nextSibling);
    }
  }

  function recalcularAlturaBarra() {
    var s = document.getElementById('shopify-section-announcement-bar');
    if (s) document.documentElement.style.setProperty('--announcement-bar-height', s.clientHeight + 'px');
  }

  function actualizarBotones() {
    var bs = document.querySelectorAll('.jl-cod-trigger');
    for (var i = 0; i < bs.length; i++) bs[i].textContent = etiquetaBoton();
    recalcularAlturaBarra();
  }

  function mensaje(panel, texto, tipo, conQuitar) {
    var p = panel.querySelector('.jl-cod-estado');
    if (!p) return;
    p.textContent = texto || '';
    p.setAttribute('data-tipo', tipo || '');
    if (conQuitar) {
      p.appendChild(document.createTextNode(' '));
      var q = document.createElement('button');
      q.type = 'button';
      q.className = 'jl-quitar';
      q.textContent = 'Quitar';
      p.appendChild(q);
    }
  }

  function estadoInicial(panel) {
    if (activo) mensaje(panel, 'Código ' + String(activo.codigo).toUpperCase() + ' aplicado · precios ya con descuento.', 'ok', true);
    else mensaje(panel, '', '');
  }

  function posicionar() {
    if (!abierto || !abierto.panel.classList.contains('jl-cod-pop--flotante')) return;
    var s = document.getElementById('shopify-section-announcement-bar');
    var r = s ? s.getBoundingClientRect() : { bottom: 0 };
    abierto.panel.style.top = Math.max(r.bottom, 0) + 6 + 'px';
  }

  function abrir(boton) {
    var panel = document.getElementById(boton.getAttribute('aria-controls'));
    if (!panel) return;
    cerrar(false);
    panel.hidden = false;
    boton.setAttribute('aria-expanded', 'true');
    abierto = { panel: panel, boton: boton };
    estadoInicial(panel);
    posicionar();
    var inp = panel.querySelector('.jl-cod-input');
    inp.value = '';
    setTimeout(function () { inp.focus(); }, 0);
  }

  function cerrar(devolverFoco) {
    if (!abierto) return;
    abierto.panel.hidden = true;
    abierto.boton.setAttribute('aria-expanded', 'false');
    if (devolverFoco) abierto.boton.focus();
    abierto = null;
  }

  /* ---------- Guardar y quitar el código (misma cookie que /discount/CÓDIGO) ---------- */
  function borrarCookie() {
    var host = location.hostname;
    var bases = ['', '; domain=' + host, '; domain=.' + host.replace(/^www\./, '')];
    for (var i = 0; i < bases.length; i++) {
      document.cookie = 'discount_code=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT' + bases[i];
    }
  }

  // Quita los códigos que tenga el carrito real (Shopify los guarda ahí al entrar por /discount/CÓDIGO).
  // Solo se llama cuando la persona pulsa «Quitar» o «Aplicar»; nunca al cargar la página.
  function limpiarCarrito() {
    try {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).catch(function () { /* si falla, la cookie y los precios ya están al día */ });
    } catch (e) { return Promise.resolve(); }
  }

  function guardarCodigo(codigo) {
    var ok = function () { return leerCookie().toUpperCase() === codigo.toUpperCase(); };
    var paso;
    try {
      // Es la misma ruta que usa el enlace de la newsletter; Shopify guarda su cookie. No es una llamada al carrito.
      paso = fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin', redirect: 'manual' })
        .catch(function () { /* se resuelve abajo */ });
    } catch (e) { paso = Promise.resolve(); }
    return paso.then(function () {
      if (!ok()) {
        document.cookie = 'discount_code=' + encodeURIComponent(codigo) + '; path=/; max-age=1209600; SameSite=Lax';
      }
      return ok();
    });
  }

  function aplicar(panel, texto) {
    var codigo = String(texto || '').trim();
    if (!codigo) {
      mensaje(panel, 'Escribe tu código y pulsa Aplicar.', 'error');
      return Promise.resolve();
    }
    var entrada = buscarCodigo(codigo);
    if (!entrada || !vigente(entrada)) {
      mensaje(panel, 'Ese código no está activo.', 'error');
      return Promise.resolve();
    }
    var boton = panel.querySelector('.jl-cod-aplicar');
    boton.disabled = true;
    return limpiarCarrito().then(function () {
      return guardarCodigo(entrada.codigo);
    }).then(function (guardado) {
      boton.disabled = false;
      if (!guardado) {
        mensaje(panel, 'No hemos podido guardar el código. Prueba de nuevo.', 'error');
        return;
      }
      sincronizar();
      mensaje(panel, 'Código ' + String(entrada.codigo).toUpperCase() + ' aplicado · precios ya con descuento.', 'ok', true);
      panel.querySelector('.jl-cod-input').value = '';
    });
  }

  function quitar() {
    borrarCookie();
    var bar = barraAviso();
    if (bar) bar.parentNode.removeChild(bar);
    sincronizar();
    var paneles = document.querySelectorAll('.jl-cod-pop');
    for (var i = 0; i < paneles.length; i++) {
      if (!paneles[i].hidden) mensaje(paneles[i], 'Código quitado. Vuelves a ver los precios normales.', 'ok');
    }
    limpiarCarrito();
  }

  /* ---------- Puesta en marcha ---------- */
  function sincronizar() {
    restaurar();
    var nombre = leerCookie();
    var c = nombre ? buscarCodigo(nombre) : null;
    activo = c && vigente(c) && pct(c) ? c : null;
    escanear();
    pintarBarra();
    montarBotones();
    actualizarBotones();
    posicionar();
    document.documentElement.classList.remove('jl-descuento-pendiente');
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var q = t.closest('.jl-quitar');
    if (q) { ev.preventDefault(); quitar(); return; }
    var b = t.closest('.jl-cod-trigger');
    if (b) {
      ev.preventDefault();
      if (abierto && abierto.boton === b) cerrar(true); else abrir(b);
      return;
    }
    if (abierto && !t.closest('.jl-cod-pop')) cerrar(false);
  });

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.classList || !f.classList.contains('jl-cod-form')) return;
    ev.preventDefault();
    var panel = f.closest('.jl-cod-pop');
    aplicar(panel, f.querySelector('.jl-cod-input').value);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && abierto) { ev.preventDefault(); cerrar(true); }
  });

  window.addEventListener('scroll', posicionar, { passive: true });
  window.addEventListener('resize', function () { posicionar(); recalcularAlturaBarra(); });

  // El tema vuelve a pintar los precios (cambio de variante, buscador, recomendados...): se vuelven a rebajar.
  var observador = new MutationObserver(function () {
    escanear();
    montarBotones();
  });

  function iniciar() {
    sincronizar();
    observador.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.JLDescuento = {
    refrescar: sincronizar,
    codigoActivo: function () { return activo ? activo.codigo : null; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
